import axios from 'axios';
import { API_URL } from '../config';

const API = API_URL;

// Get auth headers
const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`
});

// Jun-2026 (auditoría D-07): con cobertura mala la petición colgaba sin límite y
// nunca se llegaba al fallback de caché. 8 s y a IndexedDB (ver hooks/usePlaylists.js).
const READ_TIMEOUT_MS = 8000;

// Playlists API
export const playlistsApi = {
  // Get all playlists (la caché offline la gestiona hooks/usePlaylists.js con offlineDB)
  getAll: async () => {
    const { data } = await axios.get(`${API}/playlists`, {
      headers: getAuthHeaders(),
      timeout: READ_TIMEOUT_MS
    });
    return data;
  },

  // Get playlist by ID
  getById: async (playlistId) => {
    const { data } = await axios.get(`${API}/playlists/${playlistId}`, {
      headers: getAuthHeaders(),
      timeout: READ_TIMEOUT_MS
    });
    return data;
  },

  // Create playlist
  create: async (playlistData) => {
    const { data } = await axios.post(`${API}/playlists`, playlistData, {
      headers: getAuthHeaders()
    });
    return data;
  },

  // Update playlist
  update: async ({ playlistId, playlistData }) => {
    const { data } = await axios.put(`${API}/playlists/${playlistId}`, playlistData, {
      headers: getAuthHeaders()
    });
    return data;
  },

  // Delete playlist
  delete: async (playlistId) => {
    const { data } = await axios.delete(`${API}/playlists/${playlistId}`, {
      headers: getAuthHeaders()
    });
    return data;
  },

  // Generate custom list
  generateCustomList: async (playlistId) => {
    const { data } = await axios.post(
      `${API}/playlists/${playlistId}/generate-custom-list`,
      {},
      { headers: getAuthHeaders() }
    );
    return data;
  },

  // Generate AI recommendations
  generateAIRecommendations: async (playlistId) => {
    const { data } = await axios.post(
      `${API}/playlists/${playlistId}/generate-ai-recommendations`,
      {},
      { headers: getAuthHeaders() }
    );
    return data;
  },

  // Add song to custom list
  addSongToCustomList: async ({ playlistId, songId }) => {
    const { data } = await axios.post(
      `${API}/playlists/${playlistId}/add-song-to-custom-list?song_id=${songId}`,
      {},
      { headers: getAuthHeaders() }
    );
    return data;
  },

  // Remove song from custom list
  removeSongFromCustomList: async ({ playlistId, songId }) => {
    const { data } = await axios.delete(
      `${API}/playlists/${playlistId}/songs/${songId}`,
      { headers: getAuthHeaders() }
    );
    return data;
  },

  // Get calendar events
  getCalendarEvents: async () => {
    const { data } = await axios.get(`${API}/playlists/calendar/events`, {
      headers: getAuthHeaders(),
      timeout: READ_TIMEOUT_MS
    });
    return data;
  },

  // Generate client access code
  generateAccessCode: async (playlistId) => {
    const { data } = await axios.post(
      `${API}/playlists/client/generate-code/${playlistId}`,
      {},
      { headers: getAuthHeaders() }
    );
    return data;
  },
};
